module.exports = __webpack_public_path__ + "static/07-1-f666cb41fd57e846b7a6a6459a9f51b1.jpg";